import classNames from "classnames";
import { customsMock } from "./config";
import classes from "./report-customs.module.scss";

export const ReportCustoms = () => {
    return (
        <div className={classes.customs}>
            <div className={classes.customs__note}>
                По данным таможенных деклараций с 2017 года. Источник Федеральная таможенная служба.
            </div>
            <ul className={classes.customs__list}>
                {customsMock.map((item, index) => {
                    const lineClass = classNames(classes.customs__line, {
                        [classes["customs__line--inactive"]]: item.status === "inactive"
                    });
                    const pointClass = classNames(classes.customs__point, {
                        [classes["customs__point--inactive"]]: item.status === "inactive"
                    });

                    return (
                        <li key={index} className={classes.customs__item}>
                            {index < customsMock.length - 1 && <div className={lineClass} />}
                            <div className={pointClass} />
                            <div className={classes.customs__content}>
                                <div className={classes.customs__country}>{item.country}</div>
                                {item.note && item.note}
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};